"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eCommerce_1 = require("../../../utils/eCommerce");
var BaseComponent_1 = require("../../../BaseComponent");
var sweetalert2_js_1 = require("sweetalert2/dist/sweetalert2.js");
var HegydCore_1 = require("../../../components/hegyd/hegyd-core/HegydCore");
var toastr = require("toastr");
var $ = require("jquery");
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart($view) {
        var _this = _super.call(this, $view) || this;
        _this.mapBounds = [];
        _this.mapMarkers = {};
        _this.bind();
        return _this;
    }
    Cart.prototype.bind = function () {
        this.initPlugins();
        this.initEvents();
    };
    Cart.prototype.getSelectorInputQuantity = function () {
        return "input[name='product-count']";
    };
    Cart.prototype.getSelectorRemoveCartLine = function () {
        return "a.order-item-card-remove";
    };
    Cart.prototype.getSelectorCartLine = function () {
        return '.order-item-card';
    };
    Cart.prototype.getSelectorChangeShippingMeans = function () {
        return "select[name='shipping_means']";
    };
    Cart.prototype.getSelectorChangePaymentMeans = function () {
        return "select[name='payment_means']";
    };
    Cart.prototype.getSelectorChooseAddress = function () {
        return 'a.choose-address';
    };
    Cart.prototype.getSelectorAddAddress = function () {
        return 'a.add-address';
    };
    Cart.prototype.getSelectorEditAddress = function () {
        return 'a.edit-address';
    };
    Cart.prototype.getSelectorResetCart = function () {
        return 'a#reset_cart';
    };
    Cart.prototype.getElementAddCodePromo = function () {
        return $(this.getSelectorValueCodePromo());
    };
    Cart.prototype.getSelectorRemoveCodePromo = function () {
        return 'a#remove-cart';
    };
    Cart.prototype.getSelectorComment = function () {
        return '#comment';
    };
    Cart.prototype.getElementRemoveCodePromo = function () {
        return $(this.getSelectorRemoveCodePromo());
    };
    Cart.prototype.getSelectorValueCodePromo = function () {
        return 'input[name="promocode"]';
    };
    Cart.prototype.getSelectorApplyCodePromo = function () {
        return '.promo-code-input button';
    };
    Cart.prototype.getSelectorToggleFavorite = function () {
        return '.add-fav';
    };
    Cart.prototype.getAllCartTemplate = function () {
        return ['cart-header', 'cart-shopping', 'cart-sidebar'];
    };
    Cart.prototype.getSelectorCheckboxCGV = function () {
        return '#accept_cgv';
    };
    Cart.prototype.getNoValideCodeElement = function () {
        return $('#no_valide_code');
    };
    Cart.prototype.getElementLoaderModal = function () {
        return $('.loading');
    };
    Cart.prototype.getSelectorCartValidation = function () {
        return '#cart-validate';
    };
    Cart.prototype.getSelectorUpQuantity = function () {
        return '.order-item-card-description .controls .btn-left';
    };
    Cart.prototype.getSelectorDownQuantity = function () {
        return '.order-item-card-description .controls .btn-right';
    };
    Cart.prototype.hideLoader = function () {
        this.getElementLoaderModal().hide();
    };
    Cart.prototype.initPlugins = function () {
        // @ts-ignore
        Kernel.factories.CustomSelectVariant(this.$view);
        $('select.select-hidden').each(function () {
            // @ts-ignore
            Kernel.factories.CustomSelect($(this));
        });
    };
    Cart.prototype.reloadCart = function () {
        var _this = this;
        HegydCore_1.default.sendRequest($('.page-shopping-cart').data('route_refresh'), 'GET', {
            'return_templates': this.getAllCartTemplate(),
        }, function (data) {
            _this.updateCartViews(data);
            _this.initPlugins();
        });
    };
    Cart.prototype.updateProductQuantity = function ($input_quantity) {
        var _this = this;
        HegydCore_1.default.sendRequest($input_quantity.data('route'), 'PUT', {
            'product_id': $input_quantity.parents(this.getSelectorCartLine()).data('product_id'),
            'is_reference': $input_quantity.parents(this.getSelectorCartLine()).data('is_reference'),
            'user_id': $input_quantity.parents(this.getSelectorCartLine()).data('user_id'),
            'quantity': $input_quantity.val(),
            'return_templates': this.getAllCartTemplate(),
        }, function (data) {
            _this.updateCartViews(data);
            if (!data.product_added_with_success) {
                // @ts-ignore
                Kernel.factories.Toaster($('html'), 'error', data.message);
            }
            _this.initPlugins();
        });
    };
    Cart.prototype.deleteProduct = function ($remove_cross) {
        var _this = this;
        this.askToDelete($remove_cross.data('message'), $remove_cross.data('button'), function () {
            HegydCore_1.default.sendRequest($remove_cross.attr('href'), 'DELETE', {
                'product_id': $remove_cross.parents(_this.getSelectorCartLine()).data('product_id'),
                'user_id': $remove_cross.parents(_this.getSelectorCartLine()).data('user_id'),
                'is_reference': $remove_cross.parents(_this.getSelectorCartLine()).data('is_reference'),
                'return_templates': _this.getAllCartTemplate(),
            }, function () {
                window.location.reload();
            });
        });
    };
    Cart.prototype.updateCartIndexView = function (data) {
        this.updateCartViews(data);
        this.initPlugins();
    };
    Cart.prototype.updateCartViews = function (data) {
        eCommerce_1.default(data);
    };
    Cart.prototype.initCartAddressesModal = function (url, loadedCallback) {
        var _this = this;
        if (loadedCallback === void 0) { loadedCallback = null; }
        HegydCore_1.default.initRemoteModal('#cart-modal', url, loadedCallback, function (data) {
            setTimeout(function () {
                _this.updateCartViews(data);
                _this.initPlugins();
                toastr.success($('#cart-modal').data('message-address-updated-success'));
            }, 300);
        });
    };
    Cart.prototype.askToDelete = function (deleteText, buttonText, callback) {
        sweetalert2_js_1.default({
            title: deleteText.title,
            html: deleteText.message,
            allowOutsideClick: true,
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: buttonText.cancel,
            confirmButtonText: buttonText.confirm,
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve) {
                    if (callback) {
                        callback(resolve);
                    }
                });
            }
        }).then(function () {
            sweetalert2_js_1.default.close();
        });
    };
    Cart.prototype.initSelect2Countries = function () {
        // @ts-ignore
        $('#country_id').select2({
            language: 'fr',
            ajax: {
                url: '/countries',
                data: function (_a) {
                    var term = _a.term;
                    return {
                        query: term
                    };
                },
                processResults: function (data) {
                    var results = [];
                    $.each(data, function (id, entity) {
                        results.push({
                            id: entity.id,
                            text: entity.title
                        });
                    });
                    return { results: results };
                },
                templateResult: function (_a) {
                    var title = _a.title;
                    return title;
                }
            },
            initSelection: function (element, callback) {
                var id = $('[name=address_country_id]').val();
                var results = [];
                if (id) {
                    $.ajax("/countries/" + id, {
                        dataType: "json"
                    }).done(function (entity) {
                        if (entity) {
                            var id_1 = entity.id;
                            var text = entity.title;
                            results.push({ id: id_1, text: text });
                        }
                        callback(results);
                    });
                }
                callback(results);
            }
        });
    };
    Cart.prototype.deleteCart = function ($link_reset_cart) {
        var _this = this;
        this.askToDelete($link_reset_cart.data('message'), $link_reset_cart.data('btn_text'), function () {
            HegydCore_1.default.sendRequest($link_reset_cart.attr('href'), 'PUT', {
                'return_templates': _this.getAllCartTemplate()
            }, function () {
                window.location.reload();
            });
        });
    };
    Cart.prototype.selectDeliveryMode = function ($input_delivery_mode) {
        var _this = this;
        HegydCore_1.default.sendRequest($input_delivery_mode.data('route'), 'PUT', {
            'shipping_means': $input_delivery_mode.val(),
            'update-cart': true,
            'return_templates': this.getAllCartTemplate(),
        }, function (data) {
            _this.updateCartViews(data);
            _this.initPlugins();
        });
    };
    Cart.prototype.selectPaymentMean = function ($select_payment_mean) {
        var _this = this;
        HegydCore_1.default.sendRequest($select_payment_mean.data('route'), 'PUT', {
            'payment_means': $select_payment_mean.val(),
            'update-cart': true,
            'return_templates': this.getAllCartTemplate(),
        }, function (data) {
            _this.updateCartViews(data);
            _this.initPlugins();
        });
    };
    Cart.prototype.toggleFavoris = function ($element) {
        var _this = this;
        HegydCore_1.default.sendRequest($element.attr('href'), 'PUT', {}, function (_a) {
            var message = _a.message;
            // @ts-ignore
            Kernel.factories.Toaster($('html'), 'success', message);
            _this.reloadCart();
        });
    };
    Cart.prototype.toggleValidationCGV = function ($element) {
        var _this = this;
        HegydCore_1.default.sendRequest($element.data('route'), 'PUT', {
            'update-cart': true,
            'accept_cgv': $element.prop('checked') ? 1 : 0,
            'return_templates': this.getAllCartTemplate(),
        }, function (data) {
            _this.updateCartIndexView(data);
        });
    };
    Cart.prototype.updateComment = function () {
        HegydCore_1.default.sendRequest($('#comment-container').data('route'), 'PUT', {
            'update-cart': true,
            'comment': $(this.getSelectorComment()).val()
        });
    };
    Cart.prototype.applyCodePromo = function () {
        var _this = this;
        var code = this.getElementAddCodePromo().val().toString();
        if (code.length === 0) {
            this.getNoValideCodeElement().show();
            return false;
        }
        HegydCore_1.default.sendRequest(this.getElementAddCodePromo().data('route'), 'POST', {
            code: code,
            return_templates: this.getAllCartTemplate()
        }, function (data) {
            // @ts-ignore
            Kernel.factories.Toaster($('html'), 'success', data.text);
            _this.updateCartIndexView(data);
        }, function (_a) {
            var responseJSON = _a.responseJSON;
            _this.getNoValideCodeElement().empty().html(responseJSON.text).show();
        });
    };
    Cart.prototype.removeCodePromo = function () {
        var _this = this;
        HegydCore_1.default.sendRequest(this.getElementRemoveCodePromo().attr('href'), 'DELETE', {
            return_templates: this.getAllCartTemplate()
        }, function (data) {
            // @ts-ignore
            Kernel.factories.Toaster($('html'), 'success', data.text);
            _this.updateCartIndexView(data);
        });
    };
    Cart.prototype.updateQuantity = function ($element, $operation) {
        var $quantity_element = $element.parents('.order-item-card').find(this.getSelectorInputQuantity());
        var val = parseInt($quantity_element.val());
        if ($operation === "+") {
            val = val + 1;
        }
        else {
            if (val > 1) {
                val = val - 1;
            }
        }
        $quantity_element.val(val);
        $quantity_element.trigger('change');
    };
    Cart.prototype.loadColissimoFrame = function () {
        var self = this;
        $.ajax({
            // On va chercher nos paramètres nécessaires à instancier l'iFrame colissimo
            url: $('#pick-up-data-route').data('target'),
            type: 'GET',
            dataType: 'html',
            success: function (data) {
                setTimeout(function () {
                    $('#colissimo-widget-container').html(data);
                    var widget = $('.colissimo-front-widget');
                    //Initialisation de la map
                    self.initColissimoMap();
                    // Initialisation des horaires
                    self.displaySchedule();
                    // Ajout des markers sur la carte
                    self.addMarkers('colissimo');
                    // Ajout des evts sur la liste des pts relais
                    self.focusOnItemList();
                    // On affiche nos pt relais dans une modal
                    // @ts-ignore
                    widget.modal('show');
                    // on invalide la carte pour éviter un pb de chargement de tiles
                    widget.on('shown.bs.modal', function () {
                        self.map.invalidateSize();
                        self.map.fitBounds(self.mapBounds);
                    });
                    // On ajoute l'event sur notre btn validate
                    $('.save-pickUp').on('click', function (e) {
                        self.savePickUp(e.target);
                        // @ts-ignore
                        $('.colissimo-front-widget').modal('hide');
                    });
                    // Formulaire de recherche d'adresse
                    $('.change-pickup-address').on('click', function (e) {
                        self.updatePickUpSearchAddress(e.target);
                    });
                }, 200);
            }
        });
    };
    Cart.prototype.initColissimoMap = function () {
        if (this.map) {
            this.map.off();
            this.map.remove();
        }
        // @ts-ignore
        var osm = new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 21 });
        var lat = 47.11628490141351;
        var lng = -1.1219659306924472;
        var zoom = 16;
        // @ts-ignore
        this.map = new L.Map('pickUpMap')
            .addLayer(osm)
            .setView([lat, lng], zoom)
            .setMinZoom(2);
    };
    Cart.prototype.displaySchedule = function () {
        $('.colissimo-show-info').each(function () {
            $(this).on('click', function () {
                $('#collapseSchedule .content').html($(this).parent('label').next('div').html());
                // @ts-ignore
                $('#collapseSchedule').collapse('toggle');
            });
        });
        $('#collapseSchedule button').on('click', function () {
            // @ts-ignore
            $('#collapseSchedule').collapse('hide');
        });
    };
    Cart.prototype.addMarkers = function (carrier) {
        var self = this;
        self.mapMarkers = {};
        self.mapBounds = [];
        $('#pickup-list li').each(function () {
            if (!$(this).find('.coordinates .lat')[0] || !$(this).find('.coordinates .lng')[0]) {
                return;
            }
            var lat = parseFloat($(this).find('.coordinates .lat')[0].innerText);
            var lng = parseFloat($(this).find('.coordinates .lng')[0].innerText);
            var latLng = [lat, lng];
            var depositId = $(this).data('deposit');
            // @ts-ignore
            var marker = L.marker(latLng, {
                depositId: depositId
            });
            marker.setIcon(self.getMarkerIcon(carrier));
            marker.on('click', function () {
                // Ajout des evts sur le marker
                self.focusOnMarker(depositId);
            });
            marker.bindPopup("<strong>" + $(this).find('.deposit-info .name')[0].innerText + "</strong><br>" + $(this).find('.deposit-info .address')[0].innerText);
            self.mapMarkers[depositId] = marker;
            marker.addTo(self.map);
            self.mapBounds.push(latLng);
        });
    };
    Cart.prototype.getMarkerIcon = function (carrier) {
        // @ts-ignore
        return new L.icon({
            iconUrl: "/images/carriers/markers/" + carrier + ".svg",
            iconSize: [25, 30],
            popupAnchor: [0, -15]
        });
    };
    Cart.prototype.focusOnMarker = function (depositId) {
        var input = $('#pickup-' + depositId);
        if (input) {
            var list = $('#pickup-list');
            $('#pickup-list li').each(function () {
                $(this).removeClass('active');
            });
            input.prop('checked', true);
            input.parent('li').addClass('active');
            list.scrollTop(list.scrollTop() - list.offset().top + input.offset().top);
        }
    };
    Cart.prototype.focusOnItemList = function () {
        var self = this;
        $('#pickup-list li').each(function () {
            $(this).on('click', function () {
                // @ts-ignore
                $('#collapseSchedule').collapse('hide');
                var depositId = $(this).data('deposit');
                var marker = self.mapMarkers[depositId];
                marker.openPopup();
                self.map.setView(marker.getLatLng(), 14);
            });
        });
    };
    Cart.prototype.savePickUp = function (item) {
        var _a;
        var self = this;
        var point = $('input[name=pickup]:checked', '#pickup-form');
        if (typeof point !== 'undefined' && point.length > 0) {
            $.ajax({
                url: $(item).data('target'),
                type: 'PUT',
                data: {
                    point: point.val().toString(),
                    reseau: (_a = point.data('reseau')) !== null && _a !== void 0 ? _a : '',
                    cart: parseInt(point.val().toString()),
                    return_templates: self.getAllCartTemplate(),
                },
                success: function (data) {
                    self.updateCartViews(data);
                    self.initPlugins();
                }
            });
        }
    };
    Cart.prototype.updatePickUpSearchAddress = function (item) {
        var self = this;
        $.ajax({
            url: $(item).data('target'),
            type: 'GET',
            data: {
                address: $('.colissimo-address .address').val(),
                postCode: $('.colissimo-address .postcode').val(),
                city: $('.colissimo-address .city').val(),
                country: $('.colissimo-address .country').val(),
            },
            success: function (data) {
                if (data) {
                    $('.colissimo-front-widget .pickup-result-container').replaceWith(data);
                    //Initialisation de la map
                    self.initColissimoMap();
                    // Initialisation des horaires
                    self.displaySchedule();
                    // Ajout des markers sur la carte
                    self.addMarkers('colissimo');
                    // Ajout des evts sur la liste des pts relais
                    self.focusOnItemList();
                    self.map.invalidateSize();
                    self.map.fitBounds(self.mapBounds);
                }
            }
        });
    };
    /* Init all cart events */
    Cart.prototype.initEvents = function () {
        var _this = this;
        /* Changement de la quantité d'une ligne */
        this.$view.on('change', this.getSelectorInputQuantity(), function (_a) {
            var target = _a.target;
            _this.updateProductQuantity($(target));
        });
        /* Suppression d'une ligne du panier */
        this.$view.on('click', this.getSelectorRemoveCartLine(), function (e) {
            e.preventDefault();
            _this.deleteProduct($(e.target).closest(_this.getSelectorRemoveCartLine()));
        });
        this.$view.on('change', this.getSelectorChangeShippingMeans(), function (_a) {
            var target = _a.target;
            _this.selectDeliveryMode($(target));
            // load Pick-Up
            if ($(target).children('option:selected').data('name') === 'pick-up' || $(target).children('option:selected').data('name') === 'pick-up-inter') {
                _this.loadColissimoFrame();
            }
        });
        this.$view.on('click', '#choose_pick_up_point', function () {
            _this.loadColissimoFrame();
        });
        /* Sélection d'un moyen de paiement */
        this.$view.on('change', this.getSelectorChangePaymentMeans(), function (_a) {
            var target = _a.target;
            _this.selectPaymentMean($(target));
        });
        /* Choix d'une adresse */
        this.$view.on('click', this.getSelectorChooseAddress(), function (e) {
            e.preventDefault();
            _this.initCartAddressesModal($(e.target).closest(_this.getSelectorChooseAddress()).attr('href'));
        });
        /* Ajout d'une nouvelle adresse */
        this.$view.on('click', this.getSelectorAddAddress(), function (e) {
            e.preventDefault();
            _this.initCartAddressesModal($(e.target).closest(_this.getSelectorAddAddress()).attr('href'), function () {
                _this.initSelect2Countries();
                _this.hideLoader();
            });
        });
        /* Edition d'une adresse */
        this.$view.on('click', this.getSelectorEditAddress(), function (e) {
            e.preventDefault();
            _this.initCartAddressesModal($(e.target).closest(_this.getSelectorEditAddress()).attr('href'), function () {
                _this.initSelect2Countries();
                _this.hideLoader();
            });
        });
        /* Remise à zéro du panier */
        this.$view.on('click', this.getSelectorResetCart(), function (e) {
            e.preventDefault();
            _this.deleteCart($(e.target).closest(_this.getSelectorResetCart()));
        });
        /* Validation des CGV */
        this.$view.on('change', this.getSelectorCheckboxCGV(), function (e) {
            e.preventDefault();
            _this.toggleValidationCGV($(e.target));
        });
        /* Ajout ou Suppression des favoris */
        this.$view.on('click', this.getSelectorToggleFavorite(), function (e) {
            e.preventDefault();
            _this.toggleFavoris($(e.target).closest(_this.getSelectorToggleFavorite()));
        });
        /* Ajout d'un code promotion */
        this.$view.on('click', this.getSelectorApplyCodePromo(), function (e) {
            e.preventDefault();
            _this.applyCodePromo();
        });
        /* Ajout d'un commentaire */
        this.$view.on('change', this.getSelectorComment(), function (e) {
            _this.updateComment();
        });
        /* Suppression d'un code promotion */
        this.$view.on('click', this.getSelectorRemoveCodePromo(), function (e) {
            e.preventDefault();
            _this.removeCodePromo();
        });
        /* Quantité flech up */
        this.$view.on('click', this.getSelectorUpQuantity(), function (e) {
            e.preventDefault();
            _this.updateQuantity($(e.target).closest(_this.getSelectorUpQuantity()), '+');
        });
        /* Quantité flech down */
        this.$view.on('click', this.getSelectorDownQuantity(), function (e) {
            e.preventDefault();
            _this.updateQuantity($(e.target).closest(_this.getSelectorDownQuantity()), '-');
        });
        this.$view.on('click', this.getSelectorCartValidation(), function (e) {
            var $el_a = $(e.target);
            /* Modal Monetico */
            if ($el_a.data('shipping_means') === 'monetico') {
                e.preventDefault();
                HegydCore_1.default.initRemoteModal('#cart-modal', $el_a.attr('href'), function () { }, function () { }, function () { }, false);
            }
        });
        this.$view.on('click.dismiss.bs.modal', '#add-cartModal [data-dismiss="modal"]', function () {
            window.location.reload();
        });
    };
    return Cart;
}(BaseComponent_1.default));
exports.default = Cart;
